<template>
  <div class="main">
    <template v-if="!empty">
      <el-table :data="tableData" row-key="code" border lazy :stripe="true" :highlight-current-row="true"
        :header-cell-style="{ background: '#eee', color: '#606266' }" v-loading="loading"
        element-loading-background="#fff" element-loading-text="数据正在加载中" element-loading-spinner="el-icon-loading"
        ref="refTable" :height="'calc(100% - 35px)'" @selection-change="handleSelectionChange" style="min-height:300px">
        <el-table-column type="selection" width="55"  :selectable="selected"> </el-table-column>
        <!-- <el-table-column prop="enterprise_name" label="图片编号" min-width="155"
        :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column prop="name" label="课程名称" width="150" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div style=" white-space: nowrap;">
              <el-link :underline="false">{{ row.name }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="intro" label="课程简介" width="200" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="enterprise_name" label="发布单位" width="100" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="price" label="价格(元)" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="credits" label="学分" width="60" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="audit_state" label="审核结果" width="80" :show-overflow-tooltip="true">
          <template v-slot="{ row }">
            <div style="white-space: nowrap;">
              <span v-show="row.audit_state == '1'">待审核</span>
              <span v-show="row.audit_state == '2'">已通过</span>
              <span v-show="row.audit_state == '3'">未通过</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="audit_time_str" label="审核时间" width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="utime_str" label="创建时间" width="140" :show-overflow-tooltip="true"></el-table-column>


        <!--        <el-table-column prop="file_name" label="文件名称" width="100" :show-overflow-tooltip="true"></el-table-column>-->
        <!-- <el-table-column label="是否锁定" width="80" :show-overflow-tooltip="true">
                            <template v-slot="{ row }">
                                <div style="white-space: nowrap;">
                                    <span v-show="row.lock == true">是</span>
                                    <span v-show="row.lock == false">否</span>
                                </div>
                            </template>
                        </el-table-column> -->
        <el-table-column  fixed="right" label="操作">
          <template slot-scope="scope">
            <div style=" white-space: nowrap;">
              <el-button @click="tableOper('see', scope.row)" type="text" size="small">查看</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div  style="text-align: right;">
        <el-pagination class="pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10, 20, 30]" :page-size="pagesize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </template>

    <template v-else>
      <el-empty description="暂无数据" class="empty"></el-empty>
    </template>
    <previewVideo ref="previewVideo"></previewVideo>
  </div>
</template>

<script>
import previewVideo from '@/components/trainingCourse/components/previewVideo.vue'
export default {
  components: {
    previewVideo
  },
  data() {
    return {
      empty: true,
      formatObj: {
        date1: [],
        date2: [],
        education: null
      },
      // 分页
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      // 课程视频选择
      checkList: [],
      // 表格数据
      tableData: [],
      ruleForm: {
        page: 1,
        limit: 10,
        "name": "",//视频课程名称
        "outline_id": "",//主课程详情 ID
        "contents_id": "",//课程大纲目录 ID，这里用不到
        "enterprise_id": '',//企业唯一标识
        'audit_state':'2',
        recruitment_id:'',
        // "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
      },

    };
  },
  computed: {
    formatRate() {
      console.log(this.ruleForm.ai_score);
      return Number(this.ruleForm.ai_score) ? Number(this.ruleForm.ai_score) / 20 : 0
    }
  },
  methods: {
    init(id, enterprise_id,recruitment_id,checkList) {
      this.checkList = checkList

      if (!id) {
        this.empty = true
        return
      } else {
        this.empty = false
      }
      this.ruleForm.outline_id = id
      // this.ruleForm.name = form.name
      this.ruleForm.enterprise_id = enterprise_id
      this.ruleForm.recruitment_id = recruitment_id
      this.getList()
      // this.$tools
      //   .asyncPost(
      //     this,
      //     this.$baseUrl.trainingCourseGet, {
      //     data: {
      //       outline_id: id
      //     }
      //   }).then((res) => {
      //     if (res.data.code == 0) {
      //       this.ruleForm = res.data.data


      //     } else {
      //       this.$message({ type: "error", message: res.data.msg });
      //     }
      //     this.loading = false;
      //   }).catch((err) => {
      //     this.loading = false;
      //   });

    },
    getList() {
      this.tableData = []
      this.loading = true;
      this.ruleForm.page = this.currentPage
      this.ruleForm.limit = this.pagesize

      if (!this.ruleForm.outline_id) {
        this.loading = false;
        return
      }
      this.$tools
        .asyncPost(
          this,
          this.$baseUrl.trainingCourseVideoList, {
          data: this.ruleForm
        }).then((res) => {
          if (res.data.code == 0) {

            this.tableData = res.data.data.data
            this.tableData.forEach(row => {
                const isChecked = this.checkList.some(item => item === row.id);
                if (isChecked) {
                    this.$refs.table.toggleRowSelection(row, true);
                }
            });
            this.total = res.data.data.total
          } else {
            this.$message({ type: "error", message: res.data.msg });
          }
          this.loading = false;
        }).catch((err) => { this.loading = false; });
    },
    tableOper(type, row) {
      switch (type) {
        case 'see'://查看
          this.$refs.previewVideo.dialogVisible = true;
          this.$refs.previewVideo.init(row);
          break;
        default:
          break;
      }


    },
    selected(row, selected) {
      return false //不可勾
    },

    handleSelectionChange(val) {
      this.checkList = val
      this.$emit('checkListChange', this.checkList)
    },
    handleSizeChange: function (size) {
      this.pagesize = size; //每页下拉显示数据
      this.getList();
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage; //点击第几页
      this.getList();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style lang="less" scoped>
.demo-ruleForm {
  width: 100%;
  padding-right: 10px;

  .courseImage {
    // height: 100%;

    .required {
      width: 25px;
      content: '*';
      color: #F56C6C;
      text-align: right;
      margin-right: 4px;
    }

    /deep/ .el-form-item__content {
      display: flex;
      margin-left: 0 !important;

      .courseImageUpload {
        height: 184px;
        flex: 1;
        min-width: 0;

        .el-upload.el-upload--text {
          width: 100%;
          height: calc(100% - 0px);
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 100%;
          // height: 100%;
          line-height: 184px;
          text-align: center;
        }

        img {
          height: 100%;
          width: 100%;

          object-fit: cover;
        }
      }
    }
  }
}

// 
.changeTopMargin {
  margin: 18px 0 0 0;
}

.changeMargin {
  margin: 18px 0;

  /deep/ .el-form-item {
    margin: 0px;
  }
}

.flex {
  display: flex;
  align-items: center;
}

.rate {
  width: 50px;

  /deep/ .el-input__inner {
    padding: 0 0 0 5px;
  }

  //

}

.main {
  padding:0;
  width: 100%;
  height: 100%;
  min-height:300px;

  .empty {
    width: 100%;
    height: 100%;
  }

  .box1 {
    display: flex;
    width: 100%;

    .left {
      width: 226px;
      height: 159px;
      margin-right: 20px;
      border-radius: 6px;
      overflow: hidden;
      text-align: center;
      line-height: 159px;

      img {
        width: 100%;
        height: 100%;
        //object-fit: cover;
      }

      .none-img {
        width: 30%;
        height: 30%;
        opacity: 0.5;
      }

    }

    .none-img-bg {
      background-color: #f2f2f2;
    }

    .right {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        height: 40px;
        line-height: 40px;

      }
    }
  }

  .box2 {
    display: flex;
    width: 100%;

    .left {
      width: 226px;

      margin-right: 20px;

      p {
        height: 40px;
        line-height: 40px;

        display: flex;
        align-items: center;
      }
    }

    .right {

      p {
        height: 40px;
        line-height: 40px;

      }
    }
  }

  .box3 {
    p.label {
      height: 40px;
      line-height: 40px;

    }

    p.content {
      text-indent: 2rem;
      line-height: 20px;
      // min-height: 160px;
      white-space: normal;
    }
  }

  .box4,
  .box5 {
    p {
      height: 40px;
      line-height: 40px;
    }
  }

  .box4 {
    display: flex;

    // width: 100%;
    .left {
      width: 400px;
      margin-right: 20px;

      p {
        height: 40px;
        line-height: 40px;


      }
    }
  }
}

.hasOper {
  display: flex;
  justify-content: space-between
}

</style>

export default {
    data() {
        return {
            isRead: false, // 新增：只读状态
            // ... 其他数据 ...
        }
    },
    methods: {
        // 修改 init 方法接收新参数
        init(outlineId, enterpriseId, isRead = false, defaultCheckList = []) {
            this.isRead = isRead; // 保存只读状态
            // ... 原有初始化逻辑 ...
            
            // 数据加载完成后执行默认勾选
            this.$nextTick(() => {
                if (this.isRead && defaultCheckList.length) {
                    this.tableData.forEach(row => {
                        const isChecked = defaultCheckList.some(item => item.id === row.id);
                        if (isChecked) {
                            this.$refs.table.toggleRowSelection(row, true);
                        }
                    });
                }
            });
        }
    }
}